<div *ngIf="outerTitle" class="ml-3 strong">{{ title }}</div>

<div class="card card--{{ cardType }}" [class.card-top-margin]="!outerTitle">
  <p *ngIf="!outerTitle" class="card__title">{{ title }}</p>

  <div class="card__inner d-flex">
    <ng-container *ngIf="cardType !== 'facturation'; else facturation">
      <div
        class="card__inner-data"
        [class.card__inner-data--max]="placementTypePreviewUrl != null"
      >
        <configuration-card
          *ngIf="cardType === 'configuration'"
          [firstProduct]="firstProduct"
          [products]="products"
          [collaborative]="project?.collaborative"
          [client]="client"
          [installerView]="installerView"
          [projectPlacement]="projectPlacement"
        ></configuration-card>

        <design-card
          *ngIf="cardType === 'design'"
          [products]="products"
          [collaborative]="project?.collaborative"
          [existingProject]="project?.id != null"
          [fromOldSystem]="fromOldSystem"
        ></design-card>

        <placement-card
          *ngIf="cardType === 'placement' && !!firstProduct"
          [projectPlacement]="projectPlacement"
          [project]="project"
          [subProject]="baseProject"
          [firstProduct]="firstProduct"
          [fromOldSystem]="fromOldSystem"
          [installerView]="installerView"
          [client]="client"
          (addressChanged)="addressChanged.emit($event)"
        ></placement-card>

        <execution-card
          *ngIf="cardType === 'execution'"
          [project]="project"
          [baseProject]="baseProject"
          [doFetchTourInfo]="client"
          [componentsExecuted]="componentsExecuted"
        ></execution-card>
      </div>

      <ng-container *ngIf="cardType === 'configuration'; else productAssets">
        <div
          *ngIf="placementTypePreviewUrl != null"
          class="card__inner-images"
          [style.background-image]="'url(' + placementTypePreviewUrl + ')'"
        ></div>
      </ng-container>

      <ng-template #productAssets>
        <div class="d-flex flex-column justify-content-flex-end">
          <div
            *ngIf="ipBoardExamples?.length > 0 && !(products.length > 1)"
            class="card__inner-images d-flex"
          >
            <div *ngFor="let item of ipBoardExamples; let i = index">
              <div *ngIf="isImage(item)">
                <img
                  class="max-summary-width max-summary-height clickable"
                  src="/api/assets/{{ item?.uuid }}"
                  (click)="openLightbox(ipBoardExamples, i)"
                />
              </div>
            </div>
          </div>

          <div *ngFor="let item of assets; let i = index">
            <div *ngIf="isImage(item)" class="card__inner-images ml-auto mt-3">
              <img
                class="max-summary-width max-summary-height clickable"
                src="/api/assets/{{ item?.uuid }}"
                (click)="openLightbox(assets, i)"
              />
            </div>
          </div>
          <div
            class="card__inner-pdfs"
            *ngIf="pdfList?.length > 0"
            [class.mt-3]="assets?.length > 0 || ipBoardExamples?.length > 0"
          >
            <ul>
              <li *ngFor="let pdf of pdfList">
                <a
                  target="_blank"
                  [href]="pdf?.uuid | assetSource : pdf?.localSafeUrl"
                  style="margin-right: 7px"
                  class="d-flex box"
                >
                  <mat-icon> picture_as_pdf </mat-icon>

                  <div class="filename">{{ pdf?.name }}</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </ng-template>
    </ng-container>

    <ng-template #facturation>
      <facturation-card
        [project]="project"
        [baseProject]="baseProject"
        [company]="company"
        [client]="client"
      ></facturation-card>
    </ng-template>
  </div>
</div>
